import { areaNegocioNormalize } from '../Objetos/AreaNegocioModel';
import { personasNormalize } from '../Objetos/PersonasModel';
import { telefonosNormalize } from '../Objetos/TelefonosModel';
import { direccionesNormalize } from '../Objetos/DireccionesModel';
import { direccionesUnidadesOrgNormalize } from '../Objetos/DireccionesUnidadesOrgModel';
import { eMailNormalize } from '../Objetos/EMailModel';
import { identificacionesNormalize } from '../Objetos/IdentificacionesModel';
import { observacionesNormalize } from '../Objetos/ObservacionesModel';
import { catOcupacionesNormalize } from '../Objetos/CatOcupacionesModel';
import { catUnidadesOrgNormalize } from '../Objetos/CatUnidadesOrgModel';
import { empleadosNormalize } from '../../RH/Objetos/EmpleadosModel';
import { nivelJerarquicoNormalize } from '../Objetos/NivelJerarquicoModel';
import { puestoNormalize } from '../Objetos/PuestoModel';
import { unidadesOrgEmpleadoNormalize } from '../../RH/Objetos/UnidadesOrgEmpleadoModel';
import { tipoUndiadOrganizacionalNormalize } from '../Objetos/TipoUnidadOrg';
import { zonasGeograficasNormalize } from '../Objetos/ZonasGeograficasModel';
import { catRedesSocialesNormalize } from '../Objetos/CatRedesSocialesModel';
import { personasRedesSocialesNormalize } from '../Objetos/PersonasRedesSocialesModel';
import { empresasNormalize } from '../Objetos/EmpresasModel';
import { empresasUnidadesOrgNormalize } from '../Objetos/EmpresasUnidadesOrgModel';
import { avisosPrivacidadNormalize } from '../Objetos/AvisosPrivacidadModel';

import { turnosNormalize } from '../Objetos/TurnosModel';

export const Models = {
    personas: (p) => personasNormalize(p),
    areasNegocios: (a) => areaNegocioNormalize(a),
    telefonos: (t) => telefonosNormalize(t),
    direcciones: (d) => direccionesNormalize(d),
    direccionesUnidadesOrg: (d) => direccionesUnidadesOrgNormalize(d),
    eMail: (e) => eMailNormalize(e),
    identificaciones: (i) => identificacionesNormalize(i),
    observaciones: (o) => observacionesNormalize(o),
    ocupaciones: (o) => catOcupacionesNormalize(o),
    unidadesOrg: (u) => catUnidadesOrgNormalize(u),
    empleado: (e) => empleadosNormalize(e),
    nivelJerarquico: (n) => nivelJerarquicoNormalize(n),
    puesto: (p) => puestoNormalize(p),
    turnos: (t) => turnosNormalize(t),
    unidadOrgEmpleado: (u) => unidadesOrgEmpleadoNormalize(u),
    tipoUnidadOrg: (u) => tipoUndiadOrganizacionalNormalize(u),
    zonasGeograficas: (z) => zonasGeograficasNormalize(z),
    redSocial: (z) => catRedesSocialesNormalize(z),
    personaRedSocial: (x) => personasRedesSocialesNormalize(x),
    empresas: (e) => empresasNormalize(e),
    empresasUnidadesOrg: (r) => empresasUnidadesOrgNormalize(r),
    avisosPrivacidad: (x) => avisosPrivacidadNormalize(x),
}